import { c as _c } from "react/compiler-runtime";
type UserNameProps = {
  name?: string | null;
  lastName?: string | null;
  email?: string | null;
};
const UserName = t0 => {
  const $ = _c(9);
  const {
    name,
    lastName,
    email
  } = t0;
  const hasName = name || lastName;
  let t1;
  if ($[0] !== hasName || $[1] !== lastName || $[2] !== name) {
    t1 = hasName && <div className="w-full truncate text-label-3">{name} {lastName}</div>;
    $[0] = hasName;
    $[1] = lastName;
    $[2] = name;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== email) {
    t2 = <div className="w-full truncate text-body-3 text-tertiary">{email}</div>;
    $[4] = email;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex flex-col justify-start gap-0.5 px-3 py-2 min-w-0 w-full">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default UserName;